module.exports = __webpack_public_path__ + "static/media/logoinstafooter.d0d31784.svg";